import React from 'react';
import  img from '../Group.png'
const OnDelivery = () => {
    return (
        <div>
            <div>
                  <img src={img} className="w-25"/>
            </div>
            <div>
 <h1>This is delivery guy</h1>
            </div>
        </div>
    );
};

export default OnDelivery;